<template>
    <div class="px-5 mx-5">
        <v-app class="p-4">
            <div class="col-md-12 p-0 mt-5 pt-5 mx-auto" style="border: none!important;">
                <div class="mt-5 pt-5">
                    <data-table
                            :data="datas"
                            :columns="columns"
                            :debounce-delay="3000"
                            :translate="translate"
                            :orderBy="tableProps.column"
                            :pagination="paginate"
                            :orderDir="tableProps.dir"
                            :per-page="[10, 25, 50, 100, 500]"
                            @on-table-props-changed="reloadTable"
                            class="pt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
                    >
                    </data-table>
                </div>

            </div>
        </v-app>
    </div>
</template>

<script>
import button from "@/view/pages/button";
import {dataTableProps} from "@/main";
import createTarefe from "@/view/pages/tarefe/createTarefe";
import Swal from "sweetalert2";
import CreateDefault from "@/view/pages/ads/default/createDefault";
import {debounce} from "../../../custom";

export default {
    name: "myChatList",
    components: {CreateDefault, button, dataTableProps, createTarefe},
    props: {
        UserID: {
            type: Number,
            default: () => 0
        }
    },
    data() {
        return {
            datas: {},
            translate: dataTableProps.translate,
            tableProps: dataTableProps.tableProps,
            paginate: dataTableProps.pagination,
            url: `${url}/chats/${this.UserID}`,
            dataId: '',
            columns: [
                {
                    label: '<input type="checkbox" id="selectAll">',
                    transform: (val) => {
                        return `<input type="checkbox"  data-id="${val.data.phone}">`
                    },
                    orderable: false,
                },
                {
                    label: 'ردیف',
                    transform: (val) => {
                        let row = this.datas.current_page - 1;
                        row = row * this.datas.per_page;
                        return row + val.row + 1;
                    },
                    orderable: true,
                },
                {
                    label: 'شناسه',
                    name: 'id',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'ارسال کننده',
                    name: 'sender',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'متن پیام',
                    name: 'message',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'زمان ارسال',
                    name: 'created_at_diff',
                    orderable: true,
                    searchable: true,
                },
            ],
        }
    },
    methods: {
        getDataForTable(url = this.url, query = this.tableProps) {
            const vm = this
            $.ajax({
                url: url,
                type: 'GET',
                data: query,
                fn: this.getDataForTable,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: function (data) {
                    vm.datas = data;
                }
            })
        },
        reloadTable(tableProps) {
            debounce(() => {
                this.getDataForTable(this.url, tableProps);
            }, 700);
        },
    },
    watch: {
        UserID: function () {
            this.getDataForTable();
        }
    },
    mounted() {
        this.datas = {};
        this.getDataForTable(this.url);
        $(document).on('click', '#selectAll', (element) => {
            if ($(element.target).is(':checked')) {
                $('input[type="checkbox"]').prop('checked', true);

                const selected = $('input[type="checkbox"]').map(function () {
                    return $(this).data('id')
                }).get();

                this.selectedNumber = selected;
            } else {
                $('input[type="checkbox"]').prop('checked', false)
                this.selectedNumber = []
            }
        });
    },
}
</script>

<style scoped>

</style>